<template>
    <div>
        <card-header title="User Transaction List" icon="fa-usd-circle"/>

        <card-body>
            <card-list>
                <search-list-item/>

                <subheader-list-item title="Recent Transactions" badge="3" icon="fa-history"/>
                    <menu-list-item title="Jane Doe" subtitle="Aug 1, 2020" icon="fa-usd-circle" badge="3" @action="selectTransactions()"/>

                <subheader-list-item title="All Transactions" icon="fa-money-bill-wave" badge="8"/>
                    <menu-list-item title="Jane Doe" subtitle="Aug 1, 2020" icon="fa-usd-circle" badge="3" @action="selectTransactions()"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import MenuListItem from "../../components/MenuListItem";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import SearchListItem from "../../components/common/SearchListItem";

    export default {
        components: {CardHeader, CardBody, CardList, MenuListItem, SubheaderListItem, SearchListItem},
        props: ['card', 'child'],
        methods: {
            searchTransactions: function (q) {
                this.openCard('transactions')
            },

            loadUsers: function() {
                console.log('ul: load user list: active');
                console.log('ul: load user list: recent');
                console.log('ul: load user list: new');
                this.setActive();
            },
            reload: function() {
                this.loadUsers();
            },
            setActive: function() {
                let check = (this.child && this.child.definition.component === 'user') ? parseInt(this.child.props.userId) : null;
                this.recentUsers.map(u => u.active=(u.id===check));
                this.activeUsers.map(u => u.active=(u.id===check));
                this.newUsers.map(u => u.active=(u.id===check));
            },
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {
                activeUsers: [
                    {
                        id: 2,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        email2: 'test2@test2.com',
                        active: false
                    },
                    {
                        id: 3,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        email2: 'derek.thomas2@my247ed2.com',
                        active: false
                    },
                    {
                        id: 4,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        email2: 'tester2@replay2.com',
                        active: false
                    }
                ],
                newUsers: [
                    {
                        id: 5,
                        first_name: 'Jane',
                        last_name: 'Newbie',
                        email: 'jnewb@clueless.com',
                        active: false
                    },
                    {
                        id: 6,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        active: false
                    },
                    {
                        id: 7,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        active: false
                    },
                    {
                        id: 8,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        active: false
                    },
                    {
                        id: 9,
                        first_name: 'Jane',
                        last_name: 'Newbie',
                        email: 'jnewb@clueless.com',
                        active: false
                    },
                    {
                        id: 10,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        active: false
                    },
                    {
                        id: 11,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        active: false
                    },
                    {
                        id: 12,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        active: false
                    }
                ]
            }
        },
        watch: {
            'child': function() {
                this.setActive();
            }
        },
        mounted: function() {
            this.loadUsers();
        }
    }
</script>

<style lang="scss" scoped>

</style>
